<div class="find-replace-panel" (keydown.escape)="onClose()">
  <div class="find-row">
    <mat-icon class="find-icon">search</mat-icon>
    <label for="find-replace-search-input" class="visually-hidden">{{ 'EDITOR.FIND_REPLACE.FIND_PLACEHOLDER' | translate }}</label>
    <input
      #searchInput
      id="find-replace-search-input"
      class="find-input"
      type="text"
      autocomplete="off"
      [placeholder]="'EDITOR.FIND_REPLACE.FIND_PLACEHOLDER' | translate"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchTermChange($event)"
      (keydown.enter)="onSearchInputEnter($event)"
    />
    <span class="result-count">{{ resultCountLabel }}</span>
    <div class="nav-buttons">
      <button
        mat-icon-button
        type="button"
        [disabled]="resultCount === 0"
        [attr.aria-label]="'EDITOR.FIND_REPLACE.PREVIOUS_TOOLTIP' | translate"
        [matTooltip]="'EDITOR.FIND_REPLACE.PREVIOUS_TOOLTIP' | translate"
        matTooltipPosition="above"
        (click)="goToPrevious()"
      >
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        [disabled]="resultCount === 0"
        [attr.aria-label]="'EDITOR.FIND_REPLACE.NEXT_TOOLTIP' | translate"
        [matTooltip]="'EDITOR.FIND_REPLACE.NEXT_TOOLTIP' | translate"
        matTooltipPosition="above"
        (click)="goToNext()"
      >
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>
    <div class="find-row-divider"></div>
    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="'EDITOR.FIND_REPLACE.CLOSE_TOOLTIP' | translate"
      [matTooltip]="'EDITOR.FIND_REPLACE.CLOSE_TOOLTIP' | translate"
      matTooltipPosition="above"
      (click)="onClose()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  @if (canUserEdit) {
    <div class="replace-row">
      <label for="find-replace-replace-input" class="visually-hidden">{{ 'EDITOR.FIND_REPLACE.REPLACE_PLACEHOLDER' | translate }}</label>
      <input
        id="find-replace-replace-input"
        class="replace-input"
        type="text"
        autocomplete="off"
        [placeholder]="'EDITOR.FIND_REPLACE.REPLACE_PLACEHOLDER' | translate"
        [(ngModel)]="replaceTerm"
        (ngModelChange)="onReplaceTermChange($event)"
      />
      <button mat-stroked-button type="button" class="replace-button" [disabled]="resultCount === 0" (click)="replace()">
        {{ 'EDITOR.FIND_REPLACE.REPLACE' | translate }}
      </button>
      <button mat-stroked-button type="button" class="replace-button" [disabled]="resultCount === 0" (click)="replaceAll()">
        {{ 'EDITOR.FIND_REPLACE.REPLACE_ALL' | translate }}
      </button>
    </div>
  }
</div>
